export default defineNuxtRouteMiddleware(async () => {
    const { status } = useAuth()
    if (status.value != 'authenticated') {
        const localePath = useLocalePath()
        return navigateTo(localePath('/login', 'en'));
    }
});
